var $ = require('jquery');

$(window).on('load', function() {
    initBoxes();
})
$(window).on('resize', function() {
    initBoxes();
})
function initBoxes() {
    $('.boxes__item').each(function() {
        var rowSpan = Math.ceil( ($(this).find('.boxes__item-content').outerHeight() + 32) / (10+32) );
        $(this).css('grid-row-end', 'span ' + rowSpan);
    })
}